module.exports = __webpack_public_path__ + "static/media/masthead.4db166eb.png";